exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Flyout .GroupedToolsOverflowFlyout .RibbonItem{width:100%}.Flyout .GroupedToolsOverflowFlyout .RibbonItem .Button{justify-content:left}.Flyout .GroupedToolsOverflowFlyout .RibbonItem .Button:hover{background-color:transparent}", ""]);

// exports
